import type { FC } from "react";

import type { DetailedMenu } from "~/core";
import {
  AliPay,
  EighteenPlus,
  FooterLogo,
  KdPay,
  Litecoin,
  Tether,
  WeChatPay,
} from "~/icons";
import type { PageLink } from "~/root";
import { useUiKitComponents } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Typography } from "~/shared/ui-kit/typography/Typography";

import { useFooterTranslations } from "./useFooterTranslations";

type FooterProps = {
  featureFlags: {
    isFooterNavigationLinkEnabled: boolean;
  };
  language: LanguageCode;
  menuData?: DetailedMenu;
  buildLink: (page: PageLink) => string;
};
export const FooterV2: FC<FooterProps> = ({
  featureFlags,
  menuData,
  buildLink,
}) => {
  const t = useFooterTranslations();
  const { Link } = useUiKitComponents();

  return (
    <section className="py-16 mx-auto w-full">
      <div>
        <Flex justify="center" className="mb-10">
          <FooterLogo className="scale-75 sm:scale-100" />
        </Flex>

        <div className="text-center text-gray-main">
          {featureFlags.isFooterNavigationLinkEnabled && (
            <>
              {menuData?.items?.map((item) => (
                <Link
                  className="block mt-4"
                  href={buildLink(item?.menu_item_id?.link)}
                  key={item?.menu_item_id?.id}
                >
                  <Typography size="medium">
                    {item?.menu_item_id?.translations?.[0]?.name}
                  </Typography>
                </Link>
              ))}
            </>
          )}

          <Flex
            className="max-w-[312px] md:max-w-full mx-auto flex-wrap py-10"
            justify="center"
            gap={16}
          >
            <Link
              className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center"
              href="/"
            >
              <Tether />
            </Link>
            <Link
              className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center"
              href="/"
            >
              <Litecoin />
            </Link>
            <Link
              className="bg-white/10 w-[100px] h-12  rounded-lg border border-white/25 flex justify-center items-center"
              href="/"
            >
              <WeChatPay />
            </Link>
            <Link
              className="bg-white/10  w-[100px] h-12 rounded-lg border border-white/25 flex justify-center items-center"
              href="/"
            >
              <AliPay />
            </Link>
            <Link
              className="bg-white/10  w-[100px] h-12  rounded-lg border border-white/25 flex justify-center items-center"
              href="/"
            >
              <KdPay />
            </Link>
          </Flex>

          <div className="text-white/50 pb-10">
            <Typography size="small" className="pb-1">
              {t.info.supportDescription}
            </Typography>
            <Typography
              as="span"
              size="medium"
              md={{ size: "small" }}
              className="text-[#C8A0F0]"
            >
              {t.info.supportEmail}
            </Typography>
          </div>

          <div className="text-white/50 gap-[28px] sm:gap-6 flex-col-reverse sm:flex-col flex">
            <div className=" w-full justify-center">
              <Typography size="small">{t.info.rights}</Typography>
            </div>
            <div className="flex gap-4 justify-center w-[188px] mx-auto items-center text-left">
              <div>
                <EighteenPlus />
              </div>
              <div>
                <Typography size="small">{t.info.gamblingAddictive}</Typography>
                <Typography size="small">{t.info.playResponsibly}</Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
